<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Impuestos por factura</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">BaseImponible</th>
          <th scope="col">MontoImpuesto</th>
          <th scope="col">ImpuestoNombre</th>
          <th scope="col">FacturaFechaReg</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="facturaimp in datosPaginados" :key="facturaimp.idFacturaImp">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(facturaimp.idFacturaImp)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(facturaimp.idFacturaImp)" title="Editar">edit_square</i></td>
          <td>{{facturaimp.baseImponible}}</td>
          <td>{{facturaimp.montoImpuesto}}</td>
          <td>{{facturaimp.impuestoNombre}}</td>
          <td>{{getFormattedDate(facturaimp.facturaFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteFacturaImp(facturaimp.idFacturaImp)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idFacturaImp" class="form-label">IdFacturaImp</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idFacturaImp" name="idFacturaImp" v-model="datoFacturaImp.idFacturaImp" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Factura -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFactura" class="form-label"> Factura</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFactura" name="idFactura" v-model="datoFacturaImp.idFactura">
                      <option v-for="factura in facturas" :value="factura.idFactura" :key="factura.idFactura">
                        {{ factura.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Factura -->
<!-- Botón Lista de Valores  Impuesto -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idImpuesto" class="form-label"> Impuesto</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idImpuesto" name="idImpuesto" v-model="datoFacturaImp.idImpuesto">
                      <option v-for="impuesto in impuestos" :value="impuesto.idImpuesto" :key="impuesto.idImpuesto">
                        {{ impuesto.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Impuesto -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="baseImponible" class="form-label">BaseImponible</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="baseImponible" name="baseImponible" v-model="datoFacturaImp.baseImponible" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="montoImpuesto" class="form-label">MontoImpuesto</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="montoImpuesto" name="montoImpuesto" v-model="datoFacturaImp.montoImpuesto" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarFacturaImp" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditFacturaImp" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      facturaimps : [],
      datoFacturaImp : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      facturas: [],
      impuestos: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchFacturas()
    this.fetchImpuestos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.facturaimps.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwfacturaimps/nombre/'+this.nombreBusqueda).then(response=>{
          this.facturaimps=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.facturaimps.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwfacturaimps').then(response=>{
      this.facturaimps=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.facturaimps.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idFactura'
        ,'idImpuesto'
        ,'baseImponible'
        ,'montoImpuesto'
      ];
      const requiredFieldsText = [
        'idFactura'
        ,'idImpuesto'
        ,'baseImponible'
        ,'montoImpuesto'
      ];
      return validarForm(this.datoFacturaImp, requiredFields, requiredFieldsText);
    },
    async guardarFacturaImp(){
      if(this.validarForm() === 1){
        try {
          await api.post('/facturaimps', this.datoFacturaImp)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "FacturaImp creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditFacturaImp(){
      if(this.validarForm() === 1){
        try {
          await api.post('/facturaimps', this.datoFacturaImp)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "FacturaImp creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoFacturaImp={}
      this.titulo   = 'Crear Impuestos por factura'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idFacturaImp){
      this.modalWindow = true
      if(idFacturaImp != null){    
           api.get('/vwfacturaimps/'+idFacturaImp).then(resp=>{
          this.datoFacturaImp = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Impuestos por factura'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idFacturaImp){
      if(idFacturaImp != null){
        this.$router.push('/facturaimpmd/'+idFacturaImp)
      }
    },
    async deleteFacturaImp (idFacturaImp) {
      try{
        await api.delete('/facturaimps/'+idFacturaImp)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchFacturas() {
      fetch('http://localhost:8080/api/v1/facturas')
        .then(response => response.json())
        .then(data => {
          this.facturas = data;
        })
        .catch(error => {
          console.error('Error fetching facturas:', error);
        });
    },
    fetchImpuestos() {
      fetch('http://localhost:8080/api/v1/impuestos')
        .then(response => response.json())
        .then(data => {
          this.impuestos = data;
        })
        .catch(error => {
          console.error('Error fetching impuestos:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
